export const formInitState = {
    firstName: {
        value: "",
        error: false,
        helperText: "Can't be blank. Alphabets only.",
        regex: /^[a-z.]+$/i,
    },
    lastName: {
        value: "",
        error: false,
        helperText: "Can't be blank. Alphabets only.",
        regex: /^[a-z.]+$/i,
    },
    email: {
        value: "",
        error: false,
        helperText: 'Not a valid email address',
        regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    },
    phone: {
        value: "",
        error: false,
        helperText: "Not a valid phone number",
        regex: /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/,
    },
    company: {
        value: "",
        error: false,
        helperText: "Alphabets & . only",
        regex: /^[a-z. ]+$/i,
    },
    jobTitle: {
        value: "",
        error: false,
        helperText: "Alphabets & . only",
        regex: /^[a-z. ]+$/i,
    },
    referral: {
        value: "",
        error: false,
        helperText: "Alphabets/Numbers and . & - only",
        regex: /^[a-z0-9. -]+$/i,
    },
    msg: {
        value: "",
        error: false,
        helperText: 'Alphabets, punctuations & numbers allowed',
        regex: /^[\w\d\-'".,?$]+(\s[\w\d\-'".,?$]+\.?)*$/,
    },
    isSubmitted: false,
    submitBtnVal: "Submit"
}